import { render, staticRenderFns } from "./Trivia1.vue?vue&type=template&id=f2b0a0ce&scoped=true&"
import script from "./Trivia1.vue?vue&type=script&lang=js&"
export * from "./Trivia1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b0a0ce",
  null
  
)

export default component.exports